export const facilityData = {
    facilityCode : 1001,
    facilityName : '椿泊漁業協同組合',
    logoUrl      : '/images/logo_tks.svg'
}

export const authorityList = [
    { id: '1', name: 'システム管理者' },
    { id: '2', name: '漁協ユーザ' },
    { id: '3', name: '一般ユーザ' },
]

export const styleList = [
    { id: '1', name: 'D' },
    { id: '2', name: '箱' },
]

export const kgDivision = [
    { id: '0', name: '箱' },
    { id: '1', name: 'Kg' },
]

export const fishStyleList = [
    { id: '0', name: '鮮魚' },
    { id: '1', name: '活魚' },
]

export const bidUnitList = [
    { id: '1', name: '全量' },
    { id: '2', name: 'Kg' },
    { id: '3', name: 'D' },
    { id: '4', name: '箱' },
    { id: '5', name: '匹' },
]

export const lineList = [
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
]
export const searchLineList = [
    { id: '99', name: 'すべて' },
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
]
export const bidModeList = [
    { id: '0', name: 'プール' },
    { id: '1', name: '個別' },
]
export const exportList = [
    { id: '0', name: '荷受けデータ' },
    { id: '1', name: '入札データ' },
    { id: '2', name: '事務処理データ' },
]
export const slipPrintList = [
    { id: 0, name: '仕入明細' },
    { id: 1, name: '納品明細' },
]